import React, { useState, useCallback, useMemo } from "react";
import { createAvtarName } from "../../../../../utils";
import Avatar from "../../../../../components/Avatar";
import ListBoardUser from "./ListBoardUser";

function BoardOwner({ params }) {
  const [openBoardUsersMenu, setOpenBoardUsersMenu] = useState(null);
  const open = Boolean(openBoardUsersMenu);

  const handleClose = useCallback(() => {
    setOpenBoardUsersMenu(null);
  }, []);

  const handleClick = useCallback((event) => {
    setOpenBoardUsersMenu(event.currentTarget);
  }, []);

  const avatarStyle = useMemo(() => {
    return !params?.row?.board_owner_image
      ? {
        bgcolor: params?.row?.board_owner_profile_color?.background,
        color: params?.row?.board_owner_profile_color?.text,
      }
      : {};
  }, [params?.row?.board_owner_image, params?.row?.board_owner_profile_color]);

  return (
    <>
      {open && (
        <ListBoardUser
          anchorEl={openBoardUsersMenu}
          open={open}
          handleClose={handleClose}
          id={params?.row?.board_id}
          params={params}
        />
      )}
      <div className="d-flex align-items-center">
        <div onClick={handleClick} className="cursor-pointer">
          <Avatar
            // key={`user-avtar-${el.user_id}`}
            username={params?.value}
            user_image={params?.row?.board_owner_image}
            title={params.value}
            className="user-avtar-dropdown user-avatar  mr-2"
            style={
              avatarStyle
            }
          >
            {createAvtarName(params?.value)}
          </Avatar>
        </div>
        <p>{params.value}</p>
      </div>
    </>
  );
}

const isChangeBoardOwner = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.board_id === nextProps?.params?.row?.board_id &&
    prevProps?.params?.row?.board_owner_name ===
      nextProps?.params?.row?.board_owner_name &&
    prevProps?.params?.row?.board_owner_image ===
      nextProps?.params?.row?.board_owner_image &&
    prevProps?.params?.row?.board_owner_profile_color?.text ===
      nextProps?.params?.row?.board_owner_profile_color?.text &&
    prevProps?.params?.row?.board_owner_profile_color?.background ===
      nextProps?.params?.row?.board_owner_profile_color?.background &&
    prevProps?.params?.value === nextProps?.params?.value
  );
};

export default React.memo(BoardOwner, isChangeBoardOwner);
